import React, { useState, useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useAppDispatch, useAppSelector } from "../../../hooks"
import { useGiftCard, createGiftCard } from "../../../stores/NetworkStore"
import { setGiftCardReturnMessage } from "../../../stores/LobbyStore"
import { Role, Title } from "../../../../../types"

export function GiftTab() {
  const { t } = useTranslation()
  const [inputValue, setInputValue] = useState<string>("")
  const [inputCountValue, setInputCountValue] = useState<number>(5)
  const dispatch = useAppDispatch()
  const user = useAppSelector((state) => state.network.profile)
  const giftCardReturnMessage = useAppSelector((state) => state.lobby.giftCardReturnMessage)
  const isAnonymous = false // TODO: retrieve from profile if we decide to add back anonymous users 
  const role = useAppSelector((state) => state.network.profile?.role)

  // reset current boosters on close
  useEffect(
    () => () => {
      dispatch(setGiftCardReturnMessage(""))
    },
    [dispatch]
  )

  if (user && isAnonymous) {
    return (
      <div className="my-container">
        <p>{t("profile.account.anonymous_users_name_hint")}</p>
      </div>
    )
  }

  const createGiftCardButton =
    user && role && role === Role.ADMIN ? (
      <div>
        <h3>{t("创建礼品码")}</h3>
        <div style={{ display: "flex", gap: "0.5em" }}>
          <input
            type="text"
            placeholder="5"
            onChange={(e) => {
              setInputCountValue(Number.parseInt(e.target.value))
            }}
          />
          <button
            className="bubbly blue"
            onClick={() => dispatch(createGiftCard({ count: inputCountValue }))}
          >
            {t("创建")}
          </button>
        </div>
      </div>
    ) : null

    // onClick={() => {
    //   window.open("https://ifdian.net/a/dforel", '_blank');
    // }}

  return user ? (
    <div>
      <h3>
        {/* {t("use_gift_card")} */}
        使用礼品码

      </h3>
      <div style={{ display: "flex", gap: "0.5em" }}>
        <input
          type="text"
          placeholder="aaaa-bbbb-cccc-dddd-eeeeeeeeeeee"
          onChange={(e) => {
            setInputValue(e.target.value)
          }}
        />
        <button
          className="bubbly blue"
          onClick={() => dispatch(useGiftCard({ giftCardCode: inputValue }))}
        >
          {t("使用")}
        </button>
      </div>


      {createGiftCardButton}
      
      <div>{giftCardReturnMessage}</div>

      

      <button
        className="bubbly red"
        onClick={() =>  window.open("https://ifdian.net/a/dforel", '_blank') }
      >
        {t("赞助获取礼品码")}
      </button>

    </div>
  ) : null
}
